import React, { useRef, useState, useEffect } from "react"
import { motion } from "framer-motion"
import { ChevronLeft, ChevronRight, MessageSquare } from "lucide-react"
import { collection, getDocs } from "firebase/firestore"
import { db } from "../../../firebase"
import "./style.css"

const Testimonal = () => {
  const [testimonials, setTestimonials] = useState([])
  const [loading, setLoading] = useState(true)
  const sliderRef = useRef(null)

  useEffect(() => {
    const fetchTestimonials = async () => {
      try {
        setLoading(true)
        const snap = await getDocs(collection(db, "testimonials"))
        const list = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        // Sort by date or createdAt
        list.sort((a, b) => new Date(a.createdAt || 0) - new Date(b.createdAt || 0))
        setTestimonials(list)
      } catch (error) {
        console.error("Error fetching testimonials:", error)
      } finally {
        setLoading(false)
      }
    }
    fetchTestimonials()
  }, [])

  const slideLeft = () => {
    sliderRef.current.scrollBy({ left: -300, behavior: 'smooth' })
  }

  const slideRight = () => {
    sliderRef.current.scrollBy({ left: 300, behavior: 'smooth' })
  }

  if (loading) {
    return (
      <section className='testimonial-section'>
        <div className='container'>
          <div className='section-header text-center'>
            <span className='section-badge'>Testimonials</span>
            <h2 className='section-title'>What Our <span className='text-gradient'>Students Say</span></h2>
          </div>
          <div className='testimonial-carousel-wrapper'>
            <div className='testimonial-slider'>
              {[...Array(3)].map((_, i) => (
                <div key={i} className="testimonial-card animate-pulse bg-white/5 h-64 w-80 rounded-2xl flex-shrink-0" />
              ))}
            </div>
          </div>
        </div>
      </section>
    )
  }

  return (
    <section className='testimonial-section'>
      <div className='container'>
        <div className='section-header text-center'>
          <span className='section-badge'>Testimonials</span>
          <h2 className='section-title'>What Our <span className='text-gradient'>Students Say</span></h2>
          <p className='section-desc mx-auto'>Real stories from students who achieved their dreams with Welsh Education Group.</p>
        </div>

        <div className='testimonial-carousel-wrapper'>
          <button className='testimonial-nav-btn left' onClick={slideLeft}>
            <ChevronLeft size={24} />
          </button>

          <div className='testimonial-slider' ref={sliderRef}>
            {testimonials.length === 0 ? (
              <div className="w-full text-center py-16 text-gray-400">
                <MessageSquare size={48} className="mx-auto mb-4 opacity-50" />
                <p className="text-lg font-medium">No testimonials found</p>
              </div>
            ) : (
              testimonials.map((val, idx) => (
                <motion.div
                  key={val.id || idx}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: idx * 0.1 }}
                  className='testimonial-card'
                >
                  <div className='testimonial-photo-box'>
                    {val.cover ? (
                      <img src={val.cover} alt={val.name} className="testimonial-photo" />
                    ) : (
                      <div className="testimonial-photo" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'rgba(168, 85, 247, 0.1)', color: '#fff', fontSize: '32px', fontWeight: 'bold' }}>
                        {val.name ? val.name.charAt(0).toUpperCase() : "S"}
                      </div>
                    )}
                    <div className="testimonial-glow"></div>
                  </div>
                  <div className='testimonial-info'>
                    <h3 className="testimonial-name">{val.name}</h3>
                    <h4 className="testimonial-designation">{val.post || "Student"}</h4>
                    <div className="testimonial-divider"></div>
                    <p className="testimonial-expertise">"{val.desc}"</p>
                  </div>
                </motion.div>
              ))
            )}
          </div>

          <button className='testimonial-nav-btn right' onClick={slideRight}>
            <ChevronRight size={24} />
          </button>
        </div>
      </div>
    </section>
  )
}

export default Testimonal

